import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Link } from '@superops/ui-design-system';
import React from 'react';

function LinkCell(props) {
  const { cell, action } = props;
  const actions = cell.column.actions;
  const value = cell.value;
  const allProps = {
    ...cell,
    id: cell?.row?.original?.accountId,
    name: value
  };
  /* revisit dangerouslySetInnerHTML xss  */
  return value ? (
    <CellWrapper>
      {cell?.column?.isTrashView ? (
        <div className="ellipsis">{value}</div>
      ) : (
        <Link onClick={actions.onClick.bind(this, allProps)} removeUnderline>
          <div className="ellipsis">{value}</div>
        </Link>
      )}
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default LinkCell;
